import * as React from "react"
import { 
  ArrayInput, 
  TextInput,
  SimpleFormIterator
} from "react-admin"
import { Grid } from "@mui/material"
const DescriptionTab = () => {
  return (
    <Grid container width={{ xs: "100%", xl: 800 }} spacing={2}>
      <Grid item xs={12}>
        <TextInput source="description"
        label="描述" 
        multiline
        rows={4}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput source="specification"
        label="詳細規格" 
        multiline
        rows={8}
        />
      </Grid>
    </Grid>
  )
}

export default DescriptionTab;